var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1824_27148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1824_27148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00206 10.3846C8.75745 10.3846 9.39903 10.1202 9.92681 9.59142C10.4546 9.06263 10.7185 8.42053 10.7185 7.66513C10.7185 6.90974 10.4541 6.26816 9.92531 5.74038C9.39652 5.21261 8.75443 4.94872 7.99903 4.94872C7.24364 4.94872 6.60205 5.21311 6.07428 5.74188C5.5465 6.27067 5.28261 6.91277 5.28261 7.66817C5.28261 8.42356 5.547 9.06514 6.07578 9.59292C6.60456 10.1207 7.24666 10.3846 8.00206 10.3846ZM8.00054 9.46665C7.50054 9.46665 7.07554 9.29165 6.72554 8.94165C6.37554 8.59165 6.20054 8.16665 6.20054 7.66665C6.20054 7.16665 6.37554 6.74165 6.72554 6.39165C7.07554 6.04165 7.50054 5.86665 8.00054 5.86665C8.50054 5.86665 8.92554 6.04165 9.27554 6.39165C9.62554 6.74165 9.80054 7.16665 9.80054 7.66665C9.80054 8.16665 9.62554 8.59165 9.27554 8.94165C8.92554 9.29165 8.50054 9.46665 8.00054 9.46665ZM8.00054 12.3333C6.59713 12.3333 5.31359 11.9589 4.14992 11.2102C2.98625 10.4615 2.0574 9.47647 1.36339 8.2551C1.30784 8.15938 1.26724 8.06291 1.24159 7.96568C1.21595 7.86845 1.20312 7.76866 1.20312 7.66632C1.20312 7.56397 1.21595 7.4643 1.24159 7.3673C1.26724 7.27029 1.30784 7.17392 1.36339 7.0782C2.0574 5.85683 2.98625 4.87179 4.14992 4.12308C5.31359 3.37436 6.59713 3 8.00054 3C9.40395 3 10.6875 3.37436 11.8512 4.12308C13.0148 4.87179 13.9437 5.85683 14.6377 7.0782C14.6932 7.17392 14.7338 7.27039 14.7595 7.36762C14.7851 7.46485 14.798 7.56464 14.798 7.66698C14.798 7.76933 14.7851 7.869 14.7595 7.966C14.7338 8.06301 14.6932 8.15938 14.6377 8.2551C13.9437 9.47647 13.0148 10.4615 11.8512 11.2102C10.6875 11.9589 9.40395 12.3333 8.00054 12.3333ZM8.00054 11.3333C9.2561 11.3333 10.4089 11.0028 11.4589 10.3417C12.5089 9.68054 13.3117 8.78887 13.8672 7.66665C13.3117 6.54443 12.5089 5.65276 11.4589 4.99165C10.4089 4.33054 9.2561 3.99998 8.00054 3.99998C6.74499 3.99998 5.59221 4.33054 4.54221 4.99165C3.49221 5.65276 2.68943 6.54443 2.13388 7.66665C2.68943 8.78887 3.49221 9.68054 4.54221 10.3417C5.59221 11.0028 6.74499 11.3333 8.00054 11.3333Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.dc4913f0f2cee6d2423f7bc9ea68a54a.svg";
export { ForwardRef as ReactComponent };